<template>
    <div class="panel">
        <div class="panel-body">

            <el-table :data="tableData">
                <el-table-column label="加分项汇总" prop="addValue">
                </el-table-column>
                <el-table-column label="减分项汇总" prop="subValue">
                </el-table-column>
            </el-table>

        </div>
    </div>
</template>

<script>

    export default {

        name: "addsubRecordCollectTable",

        props: ['addValue', 'subValue'],

        data() {
            return {}
        },

        computed: {

            tableData() {
                return [
                    {
                        'addValue': this.addValue,
                        'subValue': this.subValue,
                    }
                ]
            },

        },

    }

</script>